import {
  GET_LIST_NHANVAY,
  GET_LIST_NHANVAY_SUCCESS,
  GET_LIST_NHANVAY_FAILURE,
} from "../../actions/NhanVay/actionTypes";

const initialState = {
  getListNhanVayLoading: false,
  objList: {
    List: [],
    TongSoTienVay: 0,
    TongLaiPhaiTra: 0,
    TongTienDaTra: 0,
    TongBanGhi: 0,
  },
};

const getListNhanVay = (state, action) => ({
  ...state,
  getListNhanVayLoading: true,
  dataSearch: action.dataSearch,
});

const getListNhanVaySuccess = (state, action) => {
  return {
    ...state,
    getListNhanVayLoading: false,
    objList: action.payload,
  };
};

const getListNhanVayFailed = (state, action) => ({
  ...state,
  getListNhanVayLoading: false,
  objList: {
    List: [],
    TongSoTienVay: 0,
    TongLaiPhaiTra: 0,
    TongTienDaTra: 0,
    TongBanGhi: 0,
  },
});

export const listNhanVayReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_NHANVAY:
      return getListNhanVay(state, action);
    case GET_LIST_NHANVAY_SUCCESS:
      return getListNhanVaySuccess(state, action);
    case GET_LIST_NHANVAY_FAILURE:
      return getListNhanVayFailed(state, action);

    default:
      return state;
  }
};

export default listNhanVayReducer;
